<template>
  <div>
    <div
      v-for="tab in tabs"
      :key="tab"
      class="inline-block mr-2 p-1 pl-3 pr-3 border cursor-pointer transition-all duration-500 select-none shadow-lg"
      :class="[
        selectedTab === tab
          ? 'text-white bg-secondary-100 border-secondary-100'
          : 'text-gray-500 hover:text-gray-700 bg-white',
      ]"
      @click="$emit('select', tab)"
    >
      {{ tab }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TabsNav',
    props: {
      tabs: {
        type: Array,
        default: () => [],
      },
      selectedTab: {
        type: String,
        default: '',
      },
    },
  };
</script>
